const HeartIconSvg = ({
  width = 15,
  height = 14,
  viewBox = '0 0 15 14',
  className = '',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M7.5 3.11571C6 -0.405121 0.75 -0.0301208 0.75 4.4699C0.75 8.96992 7.5 12.72 7.5 12.72C7.5 12.72 14.25 8.96992 14.25 4.4699C14.25 -0.0301208 9 -0.405121 7.5 3.11571Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeartIconSvg;
